import * as React from "react";
import { graphql } from "gatsby";
import "../styles/main.sass";
import "../fluid-design-system/global.sass";
import Navbar from "../fluid-design-system/Navbars";
import Jumbotron from "../fluid-design-system/Jumbotrons";
import Button from "../fluid-design-system/Buttons";
import Card from "../fluid-design-system/Cards";
import Accordion from "../fluid-design-system/Accordions";
import { Container } from "react-bootstrap";
import Bef from "../images/bef.png";
import Diasorin from "../images/diasorin-logo.png";
import Mfs from "../images/logo-mfs.png";
import Bio from "../images/biology.png";
import Teaching from "../images/teaching.png";
import Growth from "../images/growth.png";
import { Player } from "video-react";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { Nav } from "react-bootstrap";
import { motion } from "framer-motion";
import Helmet from "react-helmet";
import Typewriter from "typewriter-effect";

const IndexPage = ({ data }) => {
  const [showAll, setShowAll] = React.useState(false);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="google-site-verification"
          content="Ed3KgbHLj8f7Ckff-jH7_GSBS1WwWs1TukAg2xqItGQ"
        />
        <meta name="robots" content="index,follow" />
        <title>Project Valsalice - Economia circolare</title>
        <meta
          name="description"
          content={
            'Le classi 4SA e 5SA del Liceo Salesiano Valsalice, insieme ad alcuni docenti di scienze, hanno intrapreso questo progetto insieme alla Bef Biosystems, al fine di partecipare al concorso Mad For Science. In caso di vittoria, il finanziamento verrà dedicato interamente alla "ristrutturazione" del laboratorio di scienze, trasformandolo in un biolaboratorio, con nuove attrezzature che ci permetteranno di provare con mano degli esperimenti realtivi proprio allo sviluppo dell\'economia circolare!'
          }
        />
        <link rel="canonical" href="https://valsaproject.netlify.app" />
      </Helmet>
      <main>
        <Navbar brand="Valsalice Project">
          <Nav.Link
            onClick={() => (window.location.href = "#about")}
            className="navLink"
            as={motion.button}
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.2 },
            }}
            whileTap={{ scale: 0.9 }}
          >
            About
          </Nav.Link>
          <Nav.Link
            onClick={() => (window.location.href = "#start")}
            className="navLink"
            as={motion.button}
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.2 },
            }}
            whileTap={{ scale: 0.9 }}
          >
            Concetti Chiave
          </Nav.Link>
          <Nav.Link
            onClick={() => (window.location.href = "#q_and_a")}
            className="navLink"
            as={motion.button}
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.2 },
            }}
            whileTap={{ scale: 0.9 }}
          >
            Q&A
          </Nav.Link>
          <Nav.Link
            onClick={() => (window.location.href = "#news")}
            className="navLink"
            as={motion.button}
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.2 },
            }}
            whileTap={{ scale: 0.9 }}
          >
            News
          </Nav.Link>
          <Nav.Link
            onClick={() => (window.location.href = "#media")}
            className="navLink"
            as={motion.button}
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.2 },
            }}
            whileTap={{ scale: 0.9 }}
          >
            Media
          </Nav.Link>
        </Navbar>
        <Jumbotron
          variant="withBackground"
          background="https://vocetempo.it/vt2018/wp-content/uploads/2019/09/17a3.jpg"
        >
          <img
            src={Mfs}
            alt="Mad For Science"
            style={{
              position: "relative",
              top: "-10px",
              width: "240px",
              filter: "brightness(1.4)",
            }}
          ></img>
          <h1>
            <Typewriter
              options={{
                strings: [
                  "La passione per la scienza <span style='font-style:italic'>fila</span> veloce.",
                  "Riciclare, uno dei goals per il 2030.",
                ],
                autoStart: true,
                loop: true,
                pauseFor: 5000,
                delay: 80,
              }}
            />
          </h1>
          <div class="custom-shape-divider-bottom-1622702640">
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                class="shape-fill"
              ></path>
            </svg>
          </div>
        </Jumbotron>
        <Container className="defaultContainer">
          <div className="logosFlex">
            <img src={Bef} alt="BEF Biosystems" className="collab_logos"></img>
            <img
              src={Diasorin}
              alt="Fondazione Diasorin"
              className="collab_logos"
            ></img>
          </div>
        </Container>
        <Container className="defaultContainer" id="about">
          <h2>About</h2>
          <p>
            La classe 5SA del Liceo Salesiano Valsalice, insieme ad alcuni
            docenti di scienze e exallievi, ha intrapreso questo progetto insieme alla
            Bef Biosystems, al fine di partecipare al concorso Mad For Science
            indetto dalla fondazione Diasorin. In caso di vittoria, il generoso
            finanziamento verrà dedicato interamente alla "ristrutturazione" del
            laboratorio di scienze, trasformandolo in un biolaboratorio, con
            nuove attrezzature che ci permetteranno di provare con mano degli
            esperimenti realtivi proprio allo sviluppo dell'economia circolare e
            della biologia molecolare!
            <br></br>Due team si sono dedicati allo studio scientifico del
            bio-compost e dei metodi per riutilizzare la materia organica.{" "}
            <br></br>Altri due team si sono dedicati alla parte promozionale del
            progetto, realizzando un video e una brand identity per il progetto!
            <br></br>Infine, un ultimo team si è dedicato alla costruzione dei
            modelli 3D e alla realizzazione del sito web rappresentativo, quello
            che state visitando in questo momento!<br></br>Ancora una volta, il
            Liceo Valsalice si è messo in gioco nella ricerca scientifica, come
            da tradizione secolare!
          </p>
        </Container>
        <Container className="defaultContainer" id="start">
          <img src={Bio} alt="Biology" width={80} height={80}></img>
          <h3>Economia circolare</h3>
          <p>
            Uno degli obiettivi fondamentali da raggiungere entro il 2030 è
            proprio quello del riciclare per preservare la biodiversità. Infatti
            si può definire con tre semplici parole: Ripara, Riusa, Ricicla. Nel
            mondo, ai giorni d'oggi si tende sempre a comprare nuovi oggetti in
            sostituzione di alcuni più datati o rotti. Così facendo si aumenta
            la produzione di gas serra, ad esempio durante lo smaltimento dei
            device elettronici. Collaboriamo insieme per la salvaguardia del
            paese, impariamo a riciclare e riutilizzare! Il nostro progetto
            vuole lavorare soprattutto sugli obiettivi{" "}
            <a
              href="https://sdgs.un.org/goals/goal9"
              target="_blank"
              rel="noreferrer"
            >
              9
            </a>
            ,{" "}
            <a
              href="https://sdgs.un.org/goals/goal11"
              target="_blank"
              rel="noreferrer"
            >
              11
            </a>{" "}
            e{" "}
            <a
              href="https://sdgs.un.org/goals/goal12"
              target="_blank"
              rel="noreferrer"
            >
              12
            </a>
            .
          </p>
          <img src={Growth} alt="Biology" width={80} height={80}></img>
          <h3>Sviluppo</h3>
          <p>
            L'economia circolare è una forma di sviluppo sostenibile! Infatti la
            ricerca scientifica, si sta dedicando allo studio della materia, in
            modo da riciclarla per la creazione di oggetti o di cibo. La nostra
            azienda partner, la Bef Biosystems, si occupa di trasformare i
            rifiuti organici, ad esempio in mangimi, prodotti per l'industria e
            concime.
          </p>
          <img src={Teaching} alt="Biology" width={80} height={80}></img>
          <h3>Formazione</h3>
          <p>
            Le classi coinvolte nel progetto eseguono formazione in molteplici
            settori per trasformare il progetto in realtà. Alcuni si dedicano
            allo studio del compost e della materia prima. Altri si dedicano
            alla creazione di modelli 3D stampabili utili allo sviluppo del
            progetto, video e sito web. Si progettano anche studi sulla
            biodiversità, sull’analisi della flora batterica delle larve e su
            nuovi possibili utilizzi dei prodotti ottenuti. Un progetto
            formativo che inserisce gli studenti nel mondo del lavoro,
            affrontando temi importanti come quello della salvaguardia
            dell'ambiente! Un progetto che coinvolgerà l’intera scuola.
          </p>
        </Container>
        <Container className="defaultContainer">
          <h2
            style={{ textAlign: "center", marginBottom: "40px" }}
            id="q_and_a"
          >
            Q&A
          </h2>
          <Accordion
            elements={[
              {
                title:
                  "Perchè abbiamo accettato la sfida lanciata dalla Fondazione Diasorin?",
                body: "Abbiamo accettato la sfida lanciata dalla Fondazione Diasorin, il nostro progetto dovrà essere selezionato tra altri 50 provenienti da tutt’Italia. Ogni anno i rifiuti organici sono responsabili del 10% delle emissioni di gas serra e sprecano 170 trilioni di acqua. Il Liceo Valsalice è particolarmente interessato alla scienza fin dai tempi remoti e vuole collaborare a questo obiettivo da raggiungere entro il 2030.",
              },
              {
                title: "Cosa dobbiamo creare?",
                body: 'In collaborazione con la Bef Biosystems, leader nel settore, dobbiamo creare la nostra "Bugs farm", volta a riciclare i rifiuti organici per la creazione di mangimi, particolarmente utilizzati nella produzione agricola.',
              },
              {
                title: "Quali strumenti sono stati utilizzati?",
                body: "Per costruire il nuovo biolaboratorio abbiamo usate alcune delle tecnologie più emergenti di questi ultimi anni. Tramite software 3D e CAD abbiamo creato rendering fotorealistici del nuovo biolaboratorio e abbiamo progettato il contenitore per il biocompost, che abbiamo poi stampato utilizzando una stampante 3D a doppio filamento. Abbiamo usato il materiale PLA, un materiale biodegradabile derivante dall'amido di mais e resistente; due proprietà fondamentali per il nostro progetto.",
              },
              {
                title: "Cosa dovremo fare?",
                body: "Non solo stampa ma anche estrazione DNA e proteine delle larve e produrre nuovo filato per tessuti.",
              },
              {
                title: "Come sarà il nuovo biolaboratorio?",
                body: (
                  <>
                    <p>
                      "Il nuovo biolaboratorio sarà attrezzato con strumenti
                      appositi per lavorare sulle procedure di bioconversione.
                      Maggiori informazioni nell'articolo dedicato!"
                    </p>
                    <Button
                      as={AniLink}
                      paintDrip
                      hex="#093f91"
                      duration={0.8}
                      to="/posts/nuovo-laboratorio"
                    >
                      Articolo dedicato al nuovo laboratorio
                    </Button>
                  </>
                ),
              },
            ]}
          />
        </Container>
        <Container className="defaultContainer newsSec" id="news">
          <h2>News</h2>
          <div className="cardsFlex">
            {data.allMdx.edges.map((post, index) => {
              if (!showAll) {
                if (index < 3) {
                  return (
                    <Card
                      variant="info"
                      image={{
                        src: "/" + post.node.frontmatter.image,
                        alt: post.node.frontmatter.title,
                      }}
                      title={post.node.frontmatter.title}
                      links={
                        <Button
                          as={AniLink}
                          paintDrip
                          hex="#093f91"
                          duration={0.8}
                          to={`/posts/${post.node.frontmatter.slug}`}
                        >
                          Scopri di più
                        </Button>
                      }
                    >
                      <p>
                        <b>Pubblicato il {post.node.frontmatter.date}</b>
                      </p>
                    </Card>
                  );
                } else {
                  return null;
                }
              } else {
                return (
                  <Card
                    variant="info"
                    image={{
                      src: "/" + post.node.frontmatter.image,
                      alt: post.node.frontmatter.title,
                    }}
                    title={post.node.frontmatter.title}
                    links={
                      <Button
                        as={AniLink}
                        paintDrip
                        hex="#093f91"
                        duration={0.8}
                        to={`/posts/${post.node.frontmatter.slug}`}
                      >
                        Scopri di più
                      </Button>
                    }
                  >
                    <p>
                      <b>Pubblicato il {post.node.frontmatter.date}</b>
                    </p>
                  </Card>
                );
              }
            })}
          </div>
          <Button
            variant="info"
            onClick={() => (showAll ? setShowAll(false) : setShowAll(true))}
          >
            {!showAll ? "Mostra tutte" : "Mostra solo recenti"}
          </Button>
        </Container>
        <Container className="defaultContainer newsSec" id="media">
          <h2>Video di presentazione</h2>
          <Player
            poster="/copertina.webp"
            src="https://res.cloudinary.com/de7xgi47n/video/upload/v1622972797/valsaproject/video_mad4science_vgtve6.mp4"
          />
        </Container>
        {/* <Container className="defaultContainer newsSec">
          <h2>Contatti</h2>
          <p style={{ marginTop: "30px" }}>
            Per maggiori informazioni riguardanti il progetto, è possibile
            contattare il referente del progetto, la Professoressa Giuliana
            Losana, all'indirizzo{" "}
            <a href="mailto:giuliana.losana@liceovalsalice.it">
              giuliana.losana@liceovalsalice.it
            </a>
          </p>
        </Container> */}
      </main>
      <footer
        style={{
          padding: "24px 0",
          background: "rgb(20,20,20)",
          color: "white",
        }}
      >
        <Container>
          <ul style={{ listStyle: "none", padding: 0 }}>
            <li>
              Sito Liceo Valsalice:{" "}
              <a style={{ color: "white" }} href="https://liceovalsalice.it">
                liceovalsalice.it
              </a>
            </li>
            <li>
              Website made with{" "}
              <span role="img" aria-label="Heart">
                ❤️
              </span>
              by{" "}
              <a style={{ color: "white" }} href="https://alessandrozolli.com">
                Alessandro Zolli
              </a>
            </li>
          </ul>
        </Container>
      </footer>
    </>
  );
};

export const pageQuery = graphql`
  {
    allMdx(sort: { fields: frontmatter___date, order: DESC }) {
      edges {
        node {
          id
          frontmatter {
            title
            image
            abstract
            slug
            date
          }
        }
      }
    }
  }
`;

export default IndexPage;
